import { ERRORS_TYPES } from './ERRORS_TYPES';

export const ERRORS_THROWS = {
  timeout: 'Request timeout error; please try again later.',
  rejectedRequest: 'Rejected request',
  somethingBad: 'Something bad happened; please try again later.'
}
